"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definitions = void 0;
const data_access_1 = require("@resclick/data-access");
exports.definitions = {
    createRoomType: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/room-types',
        response: {},
    },
    updateRoomType: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/room-types/:id',
        response: {},
    },
    findRoomTypes: {
        method: 'get',
        path: '/global-definitions/room-types',
        response: {},
    },
    findOneRoomType: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/room-types/:id',
        response: {},
    },
    createViewType: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/view-types',
        response: {},
    },
    updateViewType: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/view-types/:id',
        response: {},
    },
    findViewTypes: {
        method: 'get',
        path: '/global-definitions/view-types',
        response: {},
    },
    findOneViewType: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/view-types/:id',
        response: {},
    },
    createRoomClass: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/room-classes',
        response: {},
    },
    updateRoomClass: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/room-classes/:id',
        response: {},
    },
    findRoomClasses: {
        method: 'get',
        path: '/global-definitions/room-classes',
        response: {},
    },
    findOneRoomClass: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/room-classes/:id',
        response: {},
    },
    createRoomFeaturedAmenity: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/room-feature-amenities',
        response: {},
    },
    updateRoomFeaturedAmenity: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/room-feature-amenities/:id',
        response: {},
    },
    findRoomFeatureAmenities: {
        method: 'get',
        path: '/global-definitions/room-feature-amenities',
        response: {},
    },
    findOneRoomFeaturedAmenity: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/room-feature-amenities/:id',
        response: {},
    },
    createRoomAreaType: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/room-area-types',
        response: {},
    },
    updateRoomAreaType: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/room-area-types/:id',
        response: {},
    },
    findRoomAreaTypes: {
        method: 'get',
        path: '/global-definitions/room-area-types',
        response: {},
    },
    findOneRoomAreaType: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/room-area-types/:id',
        response: {},
    },
    createBedType: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/bed-types',
        response: {},
    },
    updateBedType: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/bed-types/:id',
        response: {},
    },
    findBedTypes: {
        method: 'get',
        path: '/global-definitions/bed-types',
        response: {},
    },
    findOneBedType: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/bed-types/:id',
        response: {},
    },
    createBedSize: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/bed-sizes',
        response: {},
    },
    updateBedSize: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/bed-sizes/:id',
        response: {},
    },
    findBedSizes: {
        method: 'get',
        path: '/global-definitions/bed-sizes',
        response: {},
    },
    findOneBedSize: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/bed-sizes/:id',
        response: {},
    },
    createBoardType: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/board-types',
        response: {},
    },
    updateBoardType: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/board-types/:id',
        response: {},
    },
    findBoardTypes: {
        method: 'get',
        path: '/global-definitions/board-types',
        response: {},
    },
    findOneBoardType: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/board-types/:id',
        response: {},
    },
    createPropertyCategory: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/property-categories',
        response: {},
    },
    updatePropertyCategory: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/property-categories/:id',
        response: {},
    },
    findPropertyCategories: {
        method: 'get',
        path: '/global-definitions/property-categories',
        response: {},
    },
    findOnePropertyCategory: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/property-categories/:id',
        response: {},
    },
    createPropertyStructureType: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/property-structure-types',
        response: {},
    },
    updatePropertyStructureType: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/property-structure-types/:id',
        response: {},
    },
    findPropertyStructureTypes: {
        method: 'get',
        path: '/global-definitions/property-structure-types',
        response: {},
    },
    findOnePropertyStructureType: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/property-structure-types/:id',
        response: {},
    },
    createPackageFeature: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/package-features',
        response: {},
    },
    updatePackageFeature: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/package-features/:id',
        response: {},
    },
    findPackageFeatures: {
        method: 'get',
        path: '/global-definitions/package-features',
        response: {},
    },
    findOnePackageFeature: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/package-features/:id',
        response: {},
    },
    createCancellationPolicyType: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/cancellation-policy-types',
        response: {},
    },
    updateCancellationPolicyType: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/cancellation-policy-types/:id',
        response: {},
    },
    findCancellationPolicyTypes: {
        method: 'get',
        path: '/global-definitions/cancellation-policy-types',
        response: {},
    },
    findOneCancellationPolicyType: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/cancellation-policy-types/:id',
        response: {},
    },
    createRatePlanType: {
        dto: data_access_1.DefinitionCreateDto,
        method: 'post',
        path: '/global-definitions/rate-plan-types',
        response: {},
    },
    updateRatePlanType: {
        dto: data_access_1.DefinitionUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/global-definitions/rate-plan-types/:id',
        response: {},
    },
    findRatePlanTypes: {
        method: 'get',
        path: '/global-definitions/rate-plan-types',
        response: {},
    },
    findOneRatePlanType: {
        method: 'get',
        params: ['id'],
        path: '/global-definitions/rate-plan-types/:id',
        response: {},
    },
};
//# sourceMappingURL=definitions.api.js.map